import React, { createContext, useContext, useState, useEffect } from 'react';
import { readGclidFromCookie, readMetaCookies } from '../utilities/trackingCookie';

// Define the shape of tracking data
const defaultTracking = {
  utm_source: null,
  utm_medium: null,
  utm_campaign: null,
  utm_term: null,
  utm_content: null,
  gclid: null,
  msclkid: null,
  fbclid: null,
  fbc: null,
  fbp: null,
  user_agent: null,
  referral_source: null
};

const TrackingContext = createContext(defaultTracking);

export function TrackingProvider({ children }) {
  const [trackingData, setTrackingData] = useState(defaultTracking);

  useEffect(() => {
    // Parse query params
    const params = new URLSearchParams(window.location.search);
    const data = { ...defaultTracking };
    const last = window.location.pathname.split('/').filter(Boolean).slice(-1)[0];

    console.log(last);

    // List of keys to pick up from query
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'msclkid', 'fbclid', 'referral_source'].forEach(key => {
      if (params.has(key)) {
        data[key] = params.get(key);
      }
    });

    // A visitor who hops from an ad landing page to the booking page arrives
    // without the click ID in the URL; recover it from the Google tag cookie.
    if (!data.gclid) {
      data.gclid = readGclidFromCookie();
    }

    // Meta ad click (the _fbc cookie, or an fbclid in the URL). Only for those
    // visitors, also keep the Meta browser ID and the user agent: hfc-etl sends the
    // booking to Meta's Conversions API, which needs them to match the click.
    const meta = readMetaCookies();
    if (meta.fbc || data.fbclid) {
      data.fbc = meta.fbc;
      data.fbp = meta.fbp;
      data.user_agent = navigator.userAgent;
    }

    // Update state
    setTrackingData(data);
  }, []);

  return <TrackingContext.Provider value={trackingData}>{children}</TrackingContext.Provider>;
}

// Custom hook to consume tracking data
export function useTracking() {
  return useContext(TrackingContext);
}
